export const GET_VERIFICATIONS_MESSAGES_HISTORY = 'providers/VerificationMessages/GET_VERIFICATIONS_MESSAGES_HISTORY';
export const GET_DETAIL_VERIFICATION_MESSAGES = 'providers/VerificationMessages/GET_DETAIL_VERIFICATION_MESSAGES';
export const CREATE_VERIFICATION_MESSAGES = 'providers/VerificationMessages/CREATE_VERIFICATION_MESSAGES';
export const DELETE_VERIFICATION_MESSAGES = 'providers/VerificationMessages/DELETE_VERIFICATION_MESSAGES';
